import { browserHistory } from 'react-router'

const initialState = {
	error: false,
	isLoading: false,
	isRequestingSearchData: false,
	isOpen: false,
	hasSearched: false,
	searchTerm: '',
	searchResults: {
		has_results: false,
		results_number: 0,
		most_relevant: {
			title: '',
			url: ''
		},
		pages: false,
		results: false
	}
}

export default function searchReducer( state = initialState, action ) {
	switch ( action.type ) {
		case 'OPEN_SEARCH':
			return {
				...state,
				isOpen: true
			}

		case 'CLOSE_SEARCH':
			return {
				...state,
				isOpen: false,
				searchTerm: ''
			}

		case 'SEARCH':
			return {
				...state,
				isOpen: true,
				searchTerm: action.value
			}

		case 'SEARCH_LOADING':
			return {
				...state,
				isLoading: true,
				error: false
			}

		case 'REQUESTING_SEARCH_DATA':
			return {
				...state,
				isRequestingSearchData: true
			}

		case 'RECEIVE_SEARCH_DATA':
			if ( action.args.blockUI ) {
				return {
					...state,
					isLoading: false,
					isRequestingSearchData: false,
					hasSearched: true,
					searchResults: action.data,
					error: false
				}
			} else {
				return {
					...state,
					isLoading: false,
					isRequestingSearchData: false,
					hasSearched: true,
					searchResults: action.data,
					error: false
				}
			}

		case 'RECEIVE_ERROR':
			return {
				...state,
				isLoading: false,
				searchResults: action.data,
				error: true
			}
	}

	return state;
}



// WEBPACK FOOTER //
// ./redux/reducers/search.jsx